/* eslint-disable react/prop-types */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import { useEnabledModulesForUser } from '@/hooks/useBranchModules';

/**
 * Redirects to the appropriate dashboard when the required module is disabled.
 * Super admins bypass the check.
 * @param {string} module - Module key (e.g. 'rozliczenia', 'media', 'grafik', 'jadlospis', 'chat')
 * @param {React.ReactNode} children - Page content to render when module is enabled
 */
export default function ModuleGuard({ module: moduleKey, children }) {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const { isModuleEnabled, isLoading } = useEnabledModulesForUser();

  const role = userProfile?.active_role || userProfile?.roles?.[0] || 'parent';

  useEffect(() => {
    if (role === 'super_admin') return;
    if (isLoading) return;

    if (!isModuleEnabled(moduleKey)) {
      const redirectTo =
        role === 'teacher' ? '/TeacherDashboard' : '/Home';
      navigate(redirectTo, { replace: true });
    }
  }, [role, moduleKey, isModuleEnabled, isLoading, navigate]);

  if (role === 'super_admin') return children;
  if (isLoading) return null;
  if (!isModuleEnabled(moduleKey)) return null;

  return children;
}
